import { FormulaLibraryEntry, FormulaScope } from '../types';
import { FormulaLibraryEntryResponse } from '../types/dto';

export const mapFormulaEntry = (dto: FormulaLibraryEntryResponse): FormulaLibraryEntry => ({
  id: dto.id,
  scope: dto.scope as FormulaScope,
  key: dto.key,
  label: dto.label,
  formulaString: dto.formulaString,
  dependsOn: dto.dependsOn,
  measureType: dto.measureType,
  createdAt: dto.createdAt,
  updatedAt: dto.updatedAt,
});
